import Store from '@/store'

export const iso3ToName = (iso, language) => {
  const lang = language || Store.state.language
  const c = ISO3.find(d => d.iso3 === iso)
  return c ? c[lang].name : iso
}

export const iso3ToSlug = (iso, language) => {
  const lang = language || Store.state.language
  const c = ISO3.find(d => d.iso3 === iso)
  return c ? c[lang].slug : iso
}

export const slugToIso = (slug, language) => {
  const lang = language || Store.state.language
  const c = ISO3.find(d => d[lang].slug === slug)
  return c ? c.iso3 : slug
}

export const nameToSlug = (name, language) => {
  const lang = language || Store.state.language
  const c = ISO3.find(d => d[lang].name === name)
  return c ? c.iso3 : name
}

const ISO3 = [
  {
    iso3: 'AGO',
    en: {
      name: 'Angola',
      slug: 'angola'
    },
    no: {
      name: 'Angola',
      slug: 'angola'
    }
  },
  {
    iso3: 'ARG',
    en: {
      name: 'Argentina',
      slug: 'argentina'
    },
    no: {
      name: 'Argentina',
      slug: 'argentina'
    }
  },
  {
    iso3: 'AUS',
    en: {
      name: 'Australia',
      slug: 'australia'
    },
    no: {
      name: 'Australia',
      slug: 'australia'
    }
  },
  {
    iso3: 'BDI',
    en: {
      name: 'Burundi',
      slug: 'burundi'
    },
    no: {
      name: 'Burundi',
      slug: 'burundi'
    }
  },
  {
    iso3: 'BGD',
    en: {
      name: 'Bangladesh',
      slug: 'bangladesh'
    },
    no: {
      name: 'Bangladesh',
      slug: 'bangladesh'
    }
  },
  {
    iso3: 'BOL',
    en: {
      name: 'Bolivia',
      slug: 'bolivia'
    },
    no: {
      name: 'Bolivia',
      slug: 'bolivia'
    }
  },
  {
    iso3: 'BRA',
    en: {
      name: 'Brazil',
      slug: 'brazil'
    },
    no: {
      name: 'Brasil',
      slug: 'brasil'
    }
  },
  {
    iso3: 'BWA',
    en: {
      name: 'Botswana',
      slug: 'botswana'
    },
    no: {
      name: 'Botswana',
      slug: 'botswana'
    }
  },
  {
    iso3: 'CAF',
    en: {
      name: 'Central African Rep.',
      slug: 'central_african_republic'
    },
    no: {
      name: 'Sentralafrikanske Rep.',
      slug: 'sentralafrikanske_republikk'
    }
  },
  {
    iso3: 'CHL',
    en: {
      name: 'Chile',
      slug: 'chile'
    },
    no: {
      name: 'Chile',
      slug: 'chile'
    }
  },
  {
    iso3: 'CIV',
    en: {
      name: 'Ivory Coast',
      slug: 'ivory_coast'
    },
    no: {
      name: 'Elfenbenskysten',
      slug: 'elfenbenskysten'
    }
  },
  {
    iso3: 'CMR',
    en: {
      name: 'Cameroon',
      slug: 'cameroon'
    },
    no: {
      name: 'Kamerun',
      slug: 'kamerun'
    }
  },
  {
    iso3: 'COD',
    en: {
      name: 'DR Congo',
      slug: 'dr_congo'
    },
    no: {
      name: 'DR Kongo',
      slug: 'dr_kongo'
    }
  },
  {
    iso3: 'COG',
    en: {
      name: 'Congo',
      slug: 'congo'
    },
    no: {
      name: 'Kongo',
      slug: 'kongo'
    }
  },
  {
    iso3: 'COL',
    en: {
      name: 'Colombia',
      slug: 'colombia'
    },
    no: {
      name: 'Colombia',
      slug: 'colombia'
    }
  },
  {
    iso3: 'COM',
    en: {
      name: 'Comoros',
      slug: 'comoros'
    },
    no: {
      name: 'Komorene',
      slug: 'komorene'
    }
  },
  {
    iso3: 'CRI',
    en: {
      name: 'Costa Rica',
      slug: 'costa_rica'
    },
    no: {
      name: 'Costa Rica',
      slug: 'costa_rica'
    }
  },
  {
    iso3: 'ECU',
    en: {
      name: 'Ecuador',
      slug: 'ecuador'
    },
    no: {
      name: 'Ecuador',
      slug: 'ecuador'
    }
  },
  {
    iso3: 'ETH',
    en: {
      name: 'Ethiopia',
      slug: 'ethiopia'
    },
    no: {
      name: 'Etiopia',
      slug: 'etiopia'
    }
  },
  {
    iso3: 'GAB',
    en: {
      name: 'Gabon',
      slug: 'gabon'
    },
    no: {
      name: 'Gabon',
      slug: 'gabon'
    }
  },
  {
    iso3: 'GHA',
    en: {
      name: 'Ghana',
      slug: 'ghana'
    },
    no: {
      name: 'Gana',
      slug: 'gana'
    }
  },
  {
    iso3: 'GIN',
    en: {
      name: 'Guinea',
      slug: 'guinea'
    },
    no: {
      name: 'Guinea',
      slug: 'guinea'
    }
  },
  {
    iso3: 'GMB',
    en: {
      name: 'The Gambia',
      slug: 'the gambia'
    },
    no: {
      name: 'Gambia',
      slug: 'gambia'
    }
  },
  {
    iso3: 'GNB',
    en: {
      name: 'Guinea-Bissau',
      slug: 'guinea-bissau'
    },
    no: {
      name: 'Guinea-Bissau',
      slug: 'guinea-bissau'
    }
  },
  {
    iso3: 'GNQ',
    en: {
      name: 'Equatorial Guinea',
      slug: 'equatorial_guinea'
    },
    no: {
      name: 'Ekvatorial Guinea',
      slug: 'ekvatorial_guinea'
    }
  },
  {
    iso3: 'GTM',
    en: {
      name: 'Guatemala',
      slug: 'guatemala'
    },
    no: {
      name: 'Guatemala',
      slug: 'guatemala'
    }
  },
  {
    iso3: 'GUF',
    en: {
      name: 'French Guiana',
      slug: 'french_guiana'
    },
    no: {
      name: 'Fransk Guiana',
      slug: 'fransk_guiana'
    }
  },
  {
    iso3: 'GUM',
    en: {
      name: 'Guam',
      slug: 'guam'
    },
    no: {
      name: 'Guam',
      slug: 'guam'
    }
  },
  {
    iso3: 'GUY',
    en: {
      name: 'Guyana',
      slug: 'guyana'
    },
    no: {
      name: 'Guyana',
      slug: 'guyana'
    }
  },
  {
    iso3: 'HND',
    en: {
      name: 'Honduras',
      slug: 'honduras'
    },
    no: {
      name: 'Honduras',
      slug: 'honduras'
    }
  },
  {
    iso3: 'IDN',
    en: {
      name: 'Indonesia',
      slug: 'indonesia'
    },
    no: {
      name: 'Indonesia',
      slug: 'indonesia'
    }
  },
  {
    iso3: 'IND',
    en: {
      name: 'India',
      slug: 'india'
    },
    no: {
      name: 'India',
      slug: 'india'
    }
  },
  {
    iso3: 'KEN',
    en: {
      name: 'Kenya',
      slug: 'kenya'
    },
    no: {
      name: 'Kenya',
      slug: 'kenya'
    }
  },
  {
    iso3: 'KHM',
    en: {
      name: 'Cambodia',
      slug: 'cambodia'
    },
    no: {
      name: 'Kambodsja',
      slug: 'kambodsja'
    }
  },
  {
    iso3: 'LAO',
    en: {
      name: 'Laos',
      slug: 'laos'
    },
    no: {
      name: 'Laos',
      slug: 'laos'
    }
  },
  {
    iso3: 'LSO',
    en: {
      name: 'Lesotho',
      slug: 'lesotho'
    },
    no: {
      name: 'Lesotho',
      slug: 'lesotho'
    }
  },
  {
    iso3: 'MEX',
    en: {
      name: 'Mexico',
      slug: 'mexico'
    },
    no: {
      name: 'Mexico',
      slug: 'mexico'
    }
  },
  {
    iso3: 'MMR',
    en: {
      name: 'Myanmar',
      slug: 'myanmar'
    },
    no: {
      name: 'Myanmar',
      slug: 'myanmar'
    }
  },
  {
    iso3: 'MOZ',
    en: {
      name: 'Mozambique',
      slug: 'mozambique'
    },
    no: {
      name: 'Mozambik',
      slug: 'mozambik'
    }
  },
  {
    iso3: 'MWI',
    en: {
      name: 'Malawi',
      slug: 'malawi'
    },
    no: {
      name: 'Malawi',
      slug: 'malawi'
    }
  },
  {
    iso3: 'MYS',
    en: {
      name: 'Malaysia',
      slug: 'malaysia'
    },
    no: {
      name: 'Malaysia',
      slug: 'malaysia'
    }
  },
  {
    iso3: 'NAM',
    en: {
      name: 'Namibia',
      slug: 'namibia'
    },
    no: {
      name: 'Namibia',
      slug: 'namibia'
    }
  },
  {
    iso3: 'NER',
    en: {
      name: 'Niger',
      slug: 'niger'
    },
    no: {
      name: 'Niger',
      slug: 'niger'
    }
  },
  {
    iso3: 'NGA',
    en: {
      name: 'Nigeria',
      slug: 'nigeria'
    },
    no: {
      name: 'Nigeria',
      slug: 'nigeria'
    }
  },
  {
    iso3: 'NIC',
    en: {
      name: 'Nicaragua',
      slug: 'nicaragua'
    },
    no: {
      name: 'Nicaragua',
      slug: 'nicaragua'
    }
  },
  {
    iso3: 'NPL',
    en: {
      name: 'Nepal',
      slug: 'nepal'
    },
    no: {
      name: 'Nepal',
      slug: 'nepal'
    }
  },
  {
    iso3: 'PAN',
    en: {
      name: 'Panama',
      slug: 'panama'
    },
    no: {
      name: 'Panama',
      slug: 'panama'
    }
  },
  {
    iso3: 'PER',
    en: {
      name: 'Peru',
      slug: 'peru'
    },
    no: {
      name: 'Peru',
      slug: 'peru'
    }
  },
  {
    iso3: 'PHL',
    en: {
      name: 'Philippines',
      slug: 'philippines'
    },
    no: {
      name: 'Filippinene',
      slug: 'filippinene'
    }
  },
  {
    iso3: 'PNG',
    en: {
      name: 'Papua New Guinea',
      slug: 'papua_new_guinea'
    },
    no: {
      name: 'Papua Ny Guinea',
      slug: 'papua_ny_guinea'
    }
  },
  {
    iso3: 'PRI',
    en: {
      name: 'Puerto Rico',
      slug: 'puerto_rico'
    },
    no: {
      name: 'Puerto Rico',
      slug: 'puerto_rico'
    }
  },
  {
    iso3: 'PRY',
    en: {
      name: 'Paraguay',
      slug: 'paraguay'
    },
    no: {
      name: 'Paraguay',
      slug: 'paraguay'
    }
  },
  {
    iso3: 'PYF',
    en: {
      name: 'French Polynesia',
      slug: 'french_polynesia'
    },
    no: {
      name: 'Fransk Polynesia',
      slug: 'fransk_polynesia'
    }
  },
  {
    iso3: 'RWA',
    en: {
      name: 'Rwanda',
      slug: 'rwanda'
    },
    no: {
      name: 'Rwanda',
      slug: 'rwanda'
    }
  },
  {
    iso3: 'SAH',
    en: {
      name: 'Western Sahara',
      slug: 'western_sahara'
    },
    no: {
      name: 'Vest-Sahara',
      slug: 'vest_sahara'
    }
  },
  {
    iso3: 'SDN',
    en: {
      name: 'Sudan',
      slug: 'sudan'
    },
    no: {
      name: 'Sudan',
      slug: 'sudan'
    }
  },
  {
    iso3: 'SDS',
    en: {
      name: 'South Sudan',
      slug: 'south_sudan'
    },
    no: {
      name: 'Sør Sudan',
      slug: 'sor_sudan'
    }
  },
  {
    iso3: 'SEN',
    en: {
      name: 'Senegal',
      slug: 'senegal'
    },
    no: {
      name: 'Senegal',
      slug: 'senegal'
    }
  },
  {
    iso3: 'SGP',
    en: {
      name: 'Singapore',
      slug: 'singapore'
    },
    no: {
      name: 'Singapore',
      slug: 'singapore'
    }
  },
  {
    iso3: 'SLE',
    en: {
      name: 'Sierra Leone',
      slug: 'sierra_leone'
    },
    no: {
      name: 'Sierra Leone',
      slug: 'sierra_leone'
    }
  },
  {
    iso3: 'SLV',
    en: {
      name: 'El Salvador',
      slug: 'el_salvador'
    },
    no: {
      name: 'El Salvador',
      slug: 'el_salvador'
    }
  },
  {
    iso3: 'SUR',
    en: {
      name: 'Suriname',
      slug: 'suriname'
    },
    no: {
      name: 'Surinam',
      slug: 'surinam'
    }
  },
  {
    iso3: 'SWZ',
    en: {
      name: 'Eswatini',
      slug: 'eswatini'
    },
    no: {
      name: 'Eswatini',
      slug: 'eswatini'
    }
  },
  {
    iso3: 'SWZ',
    en: {
      name: 'Swaziland',
      slug: 'swaziland'
    },
    no: {
      name: 'Swaziland',
      slug: 'swaziland'
    }
  },
  {
    iso3: 'SYC',
    en: {
      name: 'Seychelles',
      slug: 'seychelles'
    },
    no: {
      name: 'Seychellene',
      slug: 'seychellene'
    }
  },
  {
    iso3: 'TCD',
    en: {
      name: 'Chad',
      slug: 'chad'
    },
    no: {
      name: 'Chad',
      slug: 'chad'
    }
  },
  {
    iso3: 'THA',
    en: {
      name: 'Thailand',
      slug: 'thailand'
    },
    no: {
      name: 'Thailand',
      slug: 'thailand'
    }
  },
  {
    iso3: 'TZA',
    en: {
      name: 'Tanzania',
      slug: 'tanzania'
    },
    no: {
      name: 'Tanzania',
      slug: 'tanzania'
    }
  },
  {
    iso3: 'UGA',
    en: {
      name: 'Uganda',
      slug: 'uganda'
    },
    no: {
      name: 'Uganda',
      slug: 'uganda'
    }
  },
  {
    iso3: 'URY',
    en: {
      name: 'Uruguay',
      slug: 'uruguay'
    },
    no: {
      name: 'Uruguay',
      slug: 'uruguay'
    }
  },
  {
    iso3: 'VEN',
    en: {
      name: 'Venezuela',
      slug: 'venezuela'
    },
    no: {
      name: 'Venezuela',
      slug: 'venezuela'
    }
  },
  {
    iso3: 'VNM',
    en: {
      name: 'Vietnam',
      slug: 'vietnam'
    },
    no: {
      name: 'Vietnam',
      slug: 'vietnam'
    }
  },
  {
    iso3: 'WSM',
    en: {
      name: 'Samoa',
      slug: 'samoa'
    },
    no: {
      name: 'Samoa',
      slug: 'samoa'
    }
  },
  {
    iso3: 'ZAF',
    en: {
      name: 'South Africa',
      slug: 'south_africa'
    },
    no: {
      name: 'Sør Africa',
      slug: 'sor_africa'
    }
  },
  {
    iso3: 'ZMB',
    en: {
      name: 'Zambia',
      slug: 'zambia'
    },
    no: {
      name: 'Zambia',
      slug: 'zambia'
    }
  },
  {
    iso3: 'ZWE',
    en: {
      name: 'Zimbabwe',
      slug: 'zimbabwe'
    },
    no: {
      name: 'Zimbabwe',
      slug: 'zimbabwe'
    }
  }
]
